import { Pipe, PipeTransform } from '@angular/core';

import { getPlatform } from '../utils';

@Pipe({
	name: 'getPlatform',
	standalone: true,
})
export class GetPlatformPipe implements PipeTransform {
	/**
	 * Called to just get the current platform easily. No value is needed.
	 * @param _empty provide an empty value
	 */
	transform(_empty: null | undefined) {
		return getPlatform();
	}
}
